import { Injectable, Optional, Inject, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MemberForm } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class MemberFormService {
  #http = inject(HttpClient);
  #BASE_URL = inject(BASE_URL, { optional: true });

  submitMemberForm(formData: MemberForm) {
    return this.#http.post<MemberForm>(`${this.#BASE_URL}api/forms/member`, formData);
  }
}
